var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBluephone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_106_33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.58 11.7421L13.343 9.51007C13.1653 9.3277 12.9438 9.19392 12.6996 9.1215C12.4555 9.04909 12.1969 9.04045 11.9485 9.09641C11.7 9.15237 11.4701 9.27107 11.2806 9.44117C11.0911 9.61127 10.9484 9.8271 10.866 10.0681C10.738 10.413 10.4894 10.7 10.1663 10.8759C9.84311 11.0518 9.46719 11.1048 9.10799 11.0251C8.15268 10.6824 7.28482 10.133 6.56639 9.41617C5.84797 8.6993 5.29671 7.83263 4.95199 6.87807C4.85497 6.51846 4.90056 6.13528 5.07924 5.80847C5.25792 5.48167 5.55589 5.23648 5.91099 5.12407C6.15219 5.04281 6.36845 4.90088 6.53896 4.71191C6.70948 4.52295 6.82853 4.2933 6.88467 4.04504C6.94081 3.79678 6.93215 3.53826 6.85953 3.29431C6.78691 3.05037 6.65276 2.8292 6.46999 2.65207L4.23299 0.419066C3.93815 0.14979 3.55329 0.000488281 3.15399 0.000488281C2.75469 0.000488281 2.36983 0.14979 2.07499 0.419066L0.556989 1.93407C-0.961011 3.52907 0.716989 7.75507 4.47299 11.5001C8.22899 15.2451 12.464 17.0001 14.062 15.4071L15.58 13.9001C15.8514 13.6063 16.0021 13.221 16.0021 12.8211C16.0021 12.4211 15.8514 12.0358 15.58 11.7421V11.7421Z",
    fill: "#45A6E3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_106_33"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluephone);
export default __webpack_public_path__ + "static/media/bluephone.0da7e55a6c8eb2d531e4f9981ac8d63e.svg";
export { ForwardRef as ReactComponent };